import { scopedKey } from './scope';

// Single source of truth for "is this agent set up?" — used by the Getting Started
// checklist AND the dismissible setup banner so they never disagree.

export function countScoped(base, scope) {
  try {
    const v = JSON.parse(localStorage.getItem(scopedKey(base, scope)) || '[]');
    return Array.isArray(v) ? v.length : 0;
  } catch { return 0; }
}

export function hasText(html) {
  return String(html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim().length > 0;
}

// The four onboarding steps and whether each is done, from real data + account flags.
export function setupProgress(agent = {}, scope) {
  const steps = [
    { key: 'contacts', done: countScoped('ira_contacts', scope) > 0 },
    { key: 'properties', done: countScoped('ira_properties', scope) > 0 },
    { key: 'signature', done: hasText(agent.signature) },
    { key: 'profile', done: !!agent.publicProfile },
  ];
  const doneCount = steps.filter((s) => s.done).length;
  return { steps, doneCount, total: steps.length, allDone: doneCount === steps.length };
}
